import React from 'react';
import { Link } from 'react-router-dom';
import './PageHero.css';

export default function PageHero({ label, title, desc, breadcrumb, bgImage }) {
  return (
    <section
      className={`page-hero${bgImage ? ' page-hero-img' : ''}`}
      style={bgImage ? { backgroundImage: `url(${bgImage})` } : {}}
      aria-label={`${title} hero`}
    >
      <div className="page-hero-shape page-hero-shape-1" aria-hidden="true" />
      <div className="page-hero-shape page-hero-shape-2" aria-hidden="true" />
      <div className="container">
        <div className="page-hero-content">
          {breadcrumb && (
            <nav className="page-hero-breadcrumb" aria-label="Breadcrumb">
              <Link to="/">Home</Link>
              <span aria-hidden="true">›</span>
              <span>{breadcrumb}</span>
            </nav>
          )}
          {label && <div className="page-hero-label">{label}</div>}
          <h1 className="page-hero-title">{title}</h1>
          {desc && <p className="page-hero-desc">{desc}</p>}
        </div>
      </div>
    </section>
  );
}
